{{#if asModalDialog}}
<div class="modal-header">
	<button type="button" class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">{{TYPE_CONTROLLER type this}} - {{TR "Einstellungen"}}</h4>
</div>
<div class="modal-body">
{{/if}}
	{{#if errors.error}}
		<div class="alert alert-danger">
			{{TR errors.error}}
			{{#if errors.sysErr}}
			 ({{ERROR_TR errors.sysErr}})
			{{/if}}
		</div>
	{{/if}}
	<div class="row">
		<div class="col-xs-12">
			<div class="form-group">
				<label for="name" class="control-label">{{TR "Gerätename"}}</label>
				<input type="text" class="form-control {{#if errors.name}}parsley-error{{/if}}" id="name-input" name="name" placeholder="{{TR "Gerätename"}}" value="{{formData.name}}" maxlength="100">
				{{#if errors.name}}
				<ul class="parsley-errors-list filled" id="js-name-error">
				<li class="parsley-required">{{TR errors.name}}</li>
				</ul>
				{{/if}}
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col-xs-6">
			<div class="form-group">
				<label for="station" class="control-label">{{TR "Stationsadresse"}}</label>
				<input type="number" class="form-control {{#if errors.station}}parsley-error{{/if}}" id="station-input" name="station" placeholder="{{TR "Station"}}" value="{{formData.station}}" min="1" max="255">
				{{#if errors.station}}
				<ul class="parsley-errors-list filled" id="js-station-error">
				<li class="parsley-required">{{TR errors.station}}</li>
				</ul>
				{{/if}}
			</div>
		</div>
		<div class="col-xs-6">
			<div class="form-group">
				<label for="key_number" class="control-label">{{TR "Schlüsselzahl"}}</label>
				<input type="number" class="form-control {{#if errors.key_number}}parsley-error{{/if}}" id="key_number-input" name="key_number" placeholder="1732" value="{{formData.key_number}}" min="0" max="9999">
				{{#if errors.key_number}}
				<ul class="parsley-errors-list filled" id="js-key_number-error">
				<li class="parsley-required">{{TR errors.key_number}}</li>
				</ul>
				{{/if}}
			</div>
		</div>
	</div>
{{#if asModalDialog}}
</div>
<div class="modal-footer">
	<button id="ct-cancel" type="button" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
	<button class="btn btn-primary" id="js-success">{{TR "Speichern"}}</button>
</div>
{{/if}}
